// Document ready
$(function(){

    /* Default Hero Slider */
    $(".hero-slider.owl-carousel:not(.custom-slider)").owlCarousel({
        lazyLoad: true,
        //items: 2,
        dots: false,
        nav: true,
        navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
        ],
        loop: false,
        items:1
    });

    /* Home Slider */
    var $homeSlider = $("#main-hero--home");
    if( $homeSlider.find('.hero-slider').length ) {
        var homeSlider = $("#main-hero--home .hero-slider.owl-carousel").owlCarousel({
            lazyLoad: true,
            dots: false,
            nav: false,
            // navText: [
            //     '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
            //     '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
            //     ],
            loop: false,
            items:1,
            //animateIn: 'fadeOut',
            animateOut: 'fadeOut',
            autoplay: true,
            autoplayTimeout: 1500
        });

        homeSlider.on('change.owl.carousel', function(event) {
            $homeSlider.find('.hero-circle').addClass('anim-start');
        });
    }

    
    /* Default anchor Scroll to */
    if ( $('#development-grid').length ) {
        $('.devs-grid-view-all-js').on('click', function(e){
            e.preventDefault();
            $('#development-grid').find('.development-grid-item.is-hidden').removeClass('is-hidden');
            $('#development-grid-footer').hide();
        });
    }

    /* Default anchor Scroll to */
    $('.anchor-scroll').on('click', function(e){
        e.preventDefault();
        let targetID = ( $(this).attr('href') &&  $(this).attr('href') != 'javascript:void(0)') ? $(this).attr('href') : '';
        let $target = $(targetID);
        let scrollOffset = 0;
        let mainNavigationHeight = $('#main-navigation').outerHeight();
        let scrolldownHeight = $('.hero-section').outerHeight();

        if( targetID && $target.length ) {
            let targetPos = $target.offset().top;
            scrollOffset = targetPos - mainNavigationHeight;
        } else {
            scrollOffset = scrolldownHeight-mainNavigationHeight;
        }
        
        $('html, body').animate({ scrollTop: scrollOffset });

    });

});
